import ListCheckInStore from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/HistoryTab/ListCheckIn/ListCheckInStore";
import RevenueSummaryByEmployeeStore from "app/PatientManagement/ReportEmployeeRevenueAllocationSummary/RevenueSummaryByEmployee/RevenueSummaryByEmployeeStore";
import ReportRevenueDetailsStore from "app/PatientManagement/ReportRevenueDetails/ReportRevenueDetailsStore";
import ReportSalesStore from "app/PatientManagement/ReportSales/ReportSalesStore";
import ImageGeneralTabStore from "../TreatmentManagement/TreamentInfoDetail/ImageTreatmentTab/ImageGeneralTab/ImageGeneralTabStore";
import AppointmentListStore from "./AppointmentList/AppointmentListStore";
import AppointmentTracking from "./AppointmentTracking/AppointmentTrackingStore";
import CheckInListStore from "./CheckInList/CheckInListStore";
import PatientDuplicatePhoneStore from "./PatientDuplicatePhone/PatientDuplicatePhoneStore";
import PatientGeneralStore from "./PatientGeneral/PatientGeneralStore";
import AllServicesTabStore from "./PatientGeneral/PatientGeneralTabs/AllServicesTab/AllServicesTabStore";
import AppointmentStore from "./PatientGeneral/PatientGeneralTabs/AppointmentTab/AppointmentStore";
import ComplaintStore from "./PatientGeneral/PatientGeneralTabs/Complaint/ComplaintStore";
import CustomerJourneyTabStore from "./PatientGeneral/PatientGeneralTabs/CustomerJourneyTab/CustomerJourneyTabStore";
import EncounterDiagnosisStore from "./PatientGeneral/PatientGeneralTabs/HistoryDiagnosis/EncounterDiagnosisStore";
import ListAdviseStore from "./PatientGeneral/PatientGeneralTabs/HistoryTab/ListAdvise/ListAdviseStore";
import LoyaltyPointsStore from "./PatientGeneral/PatientGeneralTabs/LoyaltyPointsTab/LoyaltyPointsStore";
import RegisterCardStore from "./PatientGeneral/PatientGeneralTabs/RegisterCardTab/RegisterCardStore";
import RegisterMedicalSupplyStore from "./PatientGeneral/PatientGeneralTabs/RegisterProductTab/RegisterMedicalSupply/RegisterMedicalSupplyStore";
import RegisterProductStore from "./PatientGeneral/PatientGeneralTabs/RegisterProductTab/RegisterProduct/RegisterProductStore";
import RegisterServiceStore from "./PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Service/RegisterServiceStore";
import UncompletedRegisterServiceStore from "./PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Service/UncompletedRegisterServiceStore";
import RegisterTreatmentPlanStore from "./PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/TreatmentPlan/RegisterTreatmentPlanStore";
import ReviewFeedbackStore from "./PatientGeneral/PatientGeneralTabs/ReviewFeedbackTab/ReviewFeedbackStore";
import ServiceRequestItemStore from "./PatientGeneral/PatientGeneralTabs/TreatmentTab/ServiceRequestItemStore";
import PatientListStore from "./PatientList/PatientListStore";
import ReportCancelInvoiceStore from "./ReportCancelInvoice/ReportCancelInvoiceStore";
import ReportCheckinStore from "./ReportCheckin/ReportCheckinStore";
import ReportDebtStore from "./ReportDebt/ReportDebtStore";
import ReportDeductionStore from "./ReportDeduction/ReportDeductionStore";
import ReportOverviewStore from "./ReportEmployeeRevenueAllocationSummary/ReportOverview/ReportOverviewStore";
import ReportExpenseStore from "./ReportExpense/ReportExpenseStore";
import ReportInvoiceDebtStore from "./ReportInvoiceDebt/ReportInvoiceDebtStore";
import ReportInvoiceSummaryStore from "./ReportInvoiceSummary/ReportInvoiceSummaryStore";
import ReportMonneyTourStore from "./ReportMonneyTour/ReportMonneyTourStore";
import ReportPaymentStore from "./ReportPayment/ReportPaymentStore";
import ReportPriceItemStore from "./ReportPriceItem/ReportPriceItemStore";
import ReportRegisterCardStore from "./ReportRegisterCard/ReportRegisterCardStore";
import ReportRegisterDrugStore from "./ReportRegisterDrug/ReportRegisterDrugStore";
import ReportRegisterServiceStore from "./ReportRegisterService/ReportRegisterServiceStore";
import ReportRevenueAllocationStore from "./ReportRevenueAllocation/ReportRevenueAllocationStore";
import ReportRevenueDetailStore from "./ReportRevenueDetail/ReportRevenueDetailStore";
import ReportRevenueGroupServiceStore from "./ReportRevenueGroupService/ReportRevenueGroupServiceStore";
import ReportSalesAllocationStore from "./ReportSalesAllocation/ReportSalesAllocationStore";
import RewardPointListStore from "./RewardPointList/RewardPointListStore";
import TreatmentPlanCardStore from "./TreatmentPlanCard/TreatmentPlanCardStore";
import TreatmentPlanListStore from "./TreatmentPlanList/TreatmentPlanListStore";
import VoucherItemReportStore from "./VoucherItemReport/VoucherItemReportStore";
import VoucherListStore from "./VoucherList/VoucherListStore";
import VoucherOrderDepositDeductionStore from "./PatientGeneral/PatientGeneralTabs/VoucherOrderDepositDeduction/VoucherOrderDepositDeductionStore";

export const PatientManagementStore = {
  patientListStore: new PatientListStore(),
  checkInListStore: new CheckInListStore(),
  patientGeneralStore: new PatientGeneralStore(),
  listAdviseStore: new ListAdviseStore(),
  registerServiceStore: new RegisterServiceStore(),
  uncompletedRegisterServiceStore: new UncompletedRegisterServiceStore(),
  registerCardStore: new RegisterCardStore(),
  registerTreatmentPlanStore: new RegisterTreatmentPlanStore(),
  registerProductStore: new RegisterProductStore(),
  registerMedicalSupplyStore: new RegisterMedicalSupplyStore(),
  appointmentTracking: new AppointmentTracking(),
  appointmentListStore: new AppointmentListStore(),
  treatmentPlanCardStore: new TreatmentPlanCardStore(),
  treatmentPlanListStore: new TreatmentPlanListStore(),
  serviceRequestItemStore: new ServiceRequestItemStore(),
  complaintStore: new ComplaintStore(),
  reviewFeedbackStore: new ReviewFeedbackStore(),
  customerJourneyTabStore: new CustomerJourneyTabStore(),
  encounterDiagnosisStore: new EncounterDiagnosisStore(),
  rewardPointListStore: new RewardPointListStore(),
  reportPaymentStore: new ReportPaymentStore(),
  reportExpenseStore: new ReportExpenseStore(),
  reportSalesAllocationStore: new ReportSalesAllocationStore(),
  reportRevenueAllocationStore: new ReportRevenueAllocationStore(),
  patientDuplicatePhoneStore: new PatientDuplicatePhoneStore(),
  reportDebtStore: new ReportDebtStore(),
  voucherItemReportStore: new VoucherItemReportStore(),
  voucherListStore: new VoucherListStore(),
  reportCheckinStore: new ReportCheckinStore(),
  allServicesTabStore: new AllServicesTabStore(),
  reportSalesStore: new ReportSalesStore(),
  reportRevenueDetailsStore: new ReportRevenueDetailsStore(),
  listCheckInStore: new ListCheckInStore(),
  reportRegisterServiceStore: new ReportRegisterServiceStore(),
  reportRegisterDrugStore: new ReportRegisterDrugStore(),
  reportRegisterCardStore: new ReportRegisterCardStore(),
  reportInvoiceSummaryStore: new ReportInvoiceSummaryStore(),
  reportRevenueDetailStore: new ReportRevenueDetailStore(),
  reportOverviewStore: new ReportOverviewStore(),
  appointmentStore: new AppointmentStore(),
  reportCancelInvoiceStore: new ReportCancelInvoiceStore(),
  reportPriceItemStore: new ReportPriceItemStore(),
  reportRevenueGroupServiceStore: new ReportRevenueGroupServiceStore(),
  imageGeneralTabStore: new ImageGeneralTabStore(),
  loyaltyPointsStore: new LoyaltyPointsStore(),
  reportInvoiceDebtStore: new ReportInvoiceDebtStore(),
  revenueSummaryByEmployeeStore: new RevenueSummaryByEmployeeStore(),
  reportMonneyTourStore: new ReportMonneyTourStore(),
  reportDeductionStore: new ReportDeductionStore(),
  voucherDepositDeductionStore: new VoucherOrderDepositDeductionStore()
};
